import _mergeJSXProps3 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Trigger from '@cloud-sn/v-trigger';
import { format as formatFn, setHours, setMinutes, setSeconds } from 'date-fns';
import { buildComponentName } from '../utils';
import commonProps from './props';
import placements from './placements';
import Panel from './panel';
export default {
  name: buildComponentName('Timepicker'),
  props: _objectSpread({}, commonProps, {
    prefixCls: {
      type: String,
      default: 'ux-time-picker'
    },
    value: {
      type: Date,
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    popupAlign: {
      type: Object,
      default: null
    },
    popupPlacement: {
      type: String,
      default: 'bottomLeft'
    },
    popupClass: {
      type: [String, Object, Array],
      default: ''
    },
    popupStyle: {
      type: Object,
      default: null
    },
    transition: {
      type: String,
      default: 'slide-up'
    },
    getPopupContainer: {
      type: Function,
      default: null
    },
    inputName: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    builtinPlacements: {
      type: Object,
      default: function _default() {
        return placements;
      }
    },
    openValue: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    size: {
      type: String,
      default: '',
      validator: function validator(val) {
        return ['small', 'default', 'large', ''].indexOf(val) > -1;
      }
    },
    addon: {
      type: String,
      default: ''
    }
  }),
  data: function data() {
    return {
      innerValue: null,
      innerOpenValue: null,
      innerVisible: false,
      triggerRef: null
    };
  },
  computed: {
    isShowHour: function isShowHour() {
      var showHour = this.showHour,
          format = this.format;

      if (format) {
        return ['H', 'h'].some(function (k) {
          return format.indexOf(k) > -1;
        });
      }

      return showHour;
    },
    isShowMinute: function isShowMinute() {
      var showMinute = this.showMinute,
          format = this.format;

      if (format) {
        return format.indexOf('m') > -1;
      }

      return showMinute;
    },
    isShowSecond: function isShowSecond() {
      var showSecond = this.showSecond,
          format = this.format;

      if (format) {
        return format.indexOf('s') > -1;
      }

      return showSecond;
    },
    normlizeFormat: function normlizeFormat() {
      var format = this.format,
          isShowHour = this.isShowHour,
          isShowMinute = this.isShowMinute,
          isShowSecond = this.isShowSecond,
          use12Hours = this.use12Hours;

      if (format) {
        return format;
      }

      var f = [];

      if (isShowHour) {
        f.push(use12Hours ? 'h' : 'HH');
      }

      if (isShowMinute) {
        f.push('mm');
      }

      if (isShowSecond) {
        f.push('ss');
      }

      var fmt = f.join(':');
      return use12Hours ? "".concat(fmt, " A") : fmt;
    },
    formatValue: function formatValue() {
      var innerValue = this.innerValue,
          normlizeFormat = this.normlizeFormat;
      return innerValue ? formatFn(innerValue, normlizeFormat) : '';
    },
    triggerNode: function triggerNode() {
      return this.renderTrigger();
    },
    panelProps: function panelProps() {
      var _this = this;

      var prefixCls = this.prefixCls,
          normlizeFormat = this.normlizeFormat,
          innerValue = this.innerValue,
          innerOpenValue = this.innerOpenValue,
          innerVisible = this.innerVisible,
          isShowHour = this.isShowHour,
          isShowMinute = this.isShowMinute,
          isShowSecond = this.isShowSecond;
      var props = Object.keys(Panel.props).reduce(function (r, k) {
        var nr = r;
        nr[k] = _this[k];
        return nr;
      }, {});
      return _objectSpread({}, props, {
        prefixCls: "".concat(prefixCls, "-panel"),
        format: normlizeFormat,
        value: innerValue,
        openValue: innerOpenValue,
        visible: innerVisible,
        showHour: isShowHour,
        showMinute: isShowMinute,
        showSecond: isShowSecond
      });
    },
    triggerClasses: function triggerClasses() {
      var _ref;

      var prefixCls = this.prefixCls,
          size = this.size;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(size === 'small' ? 'sm' : 'lg'), size === 'small' || size === 'large'), _ref;
    },
    popupClasses: function popupClasses() {
      var _ref2;

      var prefixCls = this.prefixCls,
          isShowHour = this.isShowHour,
          isShowMinute = this.isShowMinute,
          isShowSecond = this.isShowSecond,
          use12Hours = this.use12Hours;
      var cnt = [isShowHour, isShowMinute, isShowSecond, use12Hours].filter(function (v) {
        return !!v;
      }).length;
      return _ref2 = {}, _defineProperty(_ref2, "".concat(prefixCls, "-panel"), true), _defineProperty(_ref2, "".concat(prefixCls, "-panel-narrow"), (!isShowHour || !isShowMinute || !isShowSecond) && !use12Hours), _defineProperty(_ref2, "".concat(prefixCls, "-panel-column-").concat(cnt), true), _ref2;
    }
  },
  watch: {
    value: function value(nVal) {
      this.setInnerValue(nVal, false);
    },
    openValue: function openValue(nVal) {
      if (!this.innerValue) {
        this.innerOpenValue = nVal;
      }
    },
    visible: function visible(nVal) {
      this.setInnerVisible(nVal, false);
    }
  },
  created: function created() {
    var openValue = this.openValue,
        value = this.value,
        visible = this.visible,
        setInnerValue = this.setInnerValue,
        setInnerVisible = this.setInnerVisible;
    setInnerValue(value, false);

    if (!value) {
      this.innerOpenValue = openValue;
    }

    setInnerVisible(visible, false);
  },
  mounted: function mounted() {
    var triggerRef = this.$refs.triggerRef;

    if (triggerRef) {
      this.triggerRef = triggerRef;
    }
  },
  methods: {
    focus: function focus() {
      var inputRef = this.$refs.inputRef;

      if (inputRef) {
        inputRef.focus();
      }
    },
    blur: function blur() {
      var inputRef = this.$refs.inputRef;

      if (inputRef) {
        inputRef.blur();
      }
    },
    setInnerValue: function setInnerValue(value) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.innerOpenValue = value;
      this.innerValue = value;

      if (trigger) {
        this.$emit('input', value, this.formatValue);
        this.$emit('change', value, this.formatValue);
      }
    },
    setInnerVisible: function setInnerVisible(visible) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.innerVisible = visible;

      if (trigger) {
        this.$emit('popup-visible-change', visible);
      }
    },
    onPopupVisibleChange: function onPopupVisibleChange(visible) {
      this.setInnerVisible(visible);
    },
    onKeyDown: function onKeyDown(e) {
      var setInnerVisible = this.setInnerVisible;
      e.preventDefault();

      if (e.keyCode === 40) {
        setInnerVisible(true);
      }
    },
    onChange: function onChange(value) {
      this.setInnerValue(value);
    },
    onSelect: function onSelect(type, value) {
      var innerOpenValue = this.innerOpenValue,
          setInnerValue = this.setInnerValue;
      var nVal = innerOpenValue;

      if (type === 'hour') {
        nVal = setHours(innerOpenValue, value);
      } else if (type === 'minute') {
        nVal = setMinutes(innerOpenValue, value);
      } else if (type === 'second') {
        nVal = setSeconds(innerOpenValue, value);
      }

      setInnerValue(nVal);
    },
    onClear: function onClear() {
      var openValue = this.openValue,
          setInnerValue = this.setInnerValue,
          setInnerVisible = this.setInnerVisible;
      setInnerValue(null);
      this.innerOpenValue = openValue;
      setInnerVisible(false);
    },
    renderTrigger: function renderTrigger() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          triggerClasses = this.triggerClasses,
          inputName = this.inputName,
          inputReadonly = this.inputReadonly,
          placeholder = this.placeholder,
          autocomplete = this.autocomplete,
          autofocus = this.autofocus,
          formatValue = this.formatValue,
          disabled = this.disabled,
          onKeyDown = this.onKeyDown;
      var domProps = {
        value: formatValue
      };
      var attrs = {
        name: inputName,
        readonly: inputReadonly,
        placeholder: placeholder,
        autocomplete: autocomplete,
        autofocus: autofocus,
        disabled: disabled
      };
      var on = {
        keydown: onKeyDown
      };
      return h("span", {
        "slot": "trigger",
        "class": triggerClasses
      }, [h("input", _mergeJSXProps([{}, {
        class: "".concat(prefixCls, "-input"),
        domProps: domProps,
        attrs: attrs,
        on: on,
        ref: 'inputRef'
      }])), h("span", {
        "class": "".concat(prefixCls, "-icon")
      })]);
    },
    renderPopup: function renderPopup() {
      var h = this.$createElement;
      var $slots = this.$slots,
          addon = this.addon,
          panelProps = this.panelProps,
          onSelect = this.onSelect,
          onClear = this.onClear,
          onChange = this.onChange;
      var on = {
        change: onChange,
        select: onSelect,
        clear: onClear
      };
      return h(Panel, _mergeJSXProps2([{}, {
        props: panelProps,
        on: on,
        slot: 'popup'
      }]), [h("template", {
        "slot": "addon"
      }, [$slots.addon || addon])]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        innerVisible = this.innerVisible,
        disabled = this.disabled,
        popupAlign = this.popupAlign,
        popupClass = this.popupClass,
        popupClasses = this.popupClasses,
        popupStyle = this.popupStyle,
        builtinPlacements = this.builtinPlacements,
        popupPlacement = this.popupPlacement,
        transition = this.transition,
        getPopupContainer = this.getPopupContainer,
        onPopupVisibleChange = this.onPopupVisibleChange,
        triggerNode = this.triggerNode,
        renderPopup = this.renderPopup;
    var triggerProps = {
      prefixCls: "".concat(prefixCls, "-panel"),
      visible: innerVisible,
      actions: disabled ? [] : ['click'],
      popupAlign: popupAlign,
      popupClass: [popupClasses, popupClass],
      popupStyle: popupStyle,
      builtinPlacements: builtinPlacements,
      popupPlacement: popupPlacement,
      popupTransitionName: transition,
      getPopupContainer: getPopupContainer // destroyPopupOnHide: true,

    };
    var on = {
      'popup-visible-change': onPopupVisibleChange
    };
    return h(Trigger, _mergeJSXProps3([{}, {
      props: triggerProps,
      on: on,
      ref: 'triggerRef'
    }]), [triggerNode, renderPopup()]);
  }
};